<template>
  <span>
    <span v-for="(v, index) in normalizedValue"
          :key="index"
          class="enum-item"
    >
      <template v-if="index > 0">| </template>{{ v }}
    </span>
  </span>
</template>

<script>
import ResettableTimeout from 'CORE/utils/resettable-timeout'
import DataTypeProsMixin from 'CORE/mixins/dataType'
import _ from 'lodash'

export default {
    name: 'EnumDetail',
    mixins: [
        DataTypeProsMixin,
    ],
    computed: {
        normalizedValue() {
            if (_.isArray(this.value.value.value)) {
                return this.value.value.value
            } else {
                return [this.value.value.value]
            }
        },
    },
}
</script>

<style scoped>
.enum-item {
    white-space: nowrap;
}
</style>
